<template>
  <div>
    
    <div v-if="showType == 'tag'">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="showSelectDialog">{{ title }}</el-button>
      <div class="mt10" style="min-height: 40px;">
        <el-tag v-for="wtag in withoutList" :key="wtag.id" :closable="!disabled" @close="handTagClose(wtag)">
          {{wtag.nameCn}}
        </el-tag>
      </div>
    </div>
    <div v-else-if="showType == 'table'">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="showSelectDialog">{{ title }}</el-button>
      <div class="mt10" style="min-height: 40px;">
        <vxe-table
          ref="xTree"
          :data="withoutList"
          border
          :row-config="{useKey:'id',keyField:'id'}"
          style="width: 100%">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column
            field="nameCn"
            align="center"
            title="中文名称">
          </vxe-column>
          <vxe-column
            field="nameEn"
            align="center"
            title="英文名称">
          </vxe-column>
          <vxe-column
          field="defaultValue.nameEn"
            align="center"
            title="默认值">
          </vxe-column>
          <vxe-column
          field="contentLis"
          width="80"
          align="center"
          title="涉及内容">
          <template #default="{ row }">
            <PopoverTipList
                  v-if="row.contentLis && row.contentLis.length > 0 "
                  labelValue = 'id'
                  tableType = "length"
                  tableHeight = '500px'
                  boxWidth="400"
                  :imageDisabled="true"
                  :columns="[
                    {
                      prop: 'nameCn',
                      label: '中文名称'
                    },
                    {
                      prop: 'nameEn',
                      label: '英文名称'
                    }
                  ]"
                  :selectArray="row.contentLis"
                ></PopoverTipList>
                <span v-else>-</span>
              </template>
          </vxe-column>
          <vxe-column
            align="center"
            title="操作"
            width="100">
            <template slot-scope="scope">
              <el-button @click="handTagClose(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <div v-else>
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="showSelectDialog">{{ title }}</el-button>
    </div>
    <el-dialog
    :title="title"
    :close-on-click-modal="false"
    :destroy-on-close="false"
    :append-to-body="true"
     v-dialogDrag
     width="80%"
     class="gridDialog"
    :visible.sync="visible">
    <el-row :gutter="15" style="margin-right: 0;">
    <el-col :span="24">
    <el-form size="small" :inline="true" ref="searchForm" class="query-form"  @keyup.enter.native="refreshList()" @submit.native.prevent>
         <el-form-item v-for="(search,index) in searchs" :key="index" :prop="search.prop">
          <el-input size="small" v-model="searchForms[index]" :placeholder="search.label" clearable></el-input>
         </el-form-item>
        <el-form-item>
          <el-button  type="primary" @click="refreshList()" size="small" icon="el-icon-search">查询</el-button>
          <el-button @click="resetSearch()" size="small" icon="el-icon-refresh-right">重置</el-button>
        </el-form-item>
      </el-form>
      </el-col>
    <el-col :span="14">
      <div v-if="showType != 'tree'">
    <el-table
      :data="dataList"
      v-loading="loading"
      size="small"
      ref="gridTable"
      :height="450"
      border
      @selection-change="selectionChangeHandle"
      @sort-change="sortChangeHandle"
      style="width: 100%;">
    <el-table-column
        header-align="center"
        align="center"
        v-if="limit <= 1"
        width="50">
          <template slot-scope="scope">
              <el-radio :label="scope.row.id" :value="dataListAllSelections[0]&&dataListAllSelections[0].id" @change.native="getTemplateRow(scope.$index,scope.row)"><span></span></el-radio>
          </template>
      </el-table-column>
      <el-table-column
        type="selection"
        header-align="center"
        v-if="limit > 1"
        align="center"
        width="50">
      </el-table-column>
      <template   v-for="(column, index) in columns">
      <el-table-column
        :key="index"
        :prop="column.prop"
        header-align="center"
        align="center"
        :min-width="column.width ? column.width : 100"
        :label="column.label">
        <template slot-scope="scope">
              <template v-if="column.prop == 'image'" >
                <popoverTipList
                    ref="myPopoverTipList"
                    v-if="scope.row.picJsonList && scope.row.picJsonList.length > 0 "
                    popoverTrigger="hover"
                    labelValue = 'id'
                    tableType = "length"
                    tableHeight = '500px'
                    boxWidth="200"
                    :imageDisabled="true"
                    :columns="[
                    ]"
                    :selectArray="scope.row.picJsonList"
                  ></popoverTipList>
              </template>
              <template v-else>
                {{ scope.row[column.prop] }}
              </template>
            </template>
      </el-table-column>
      </template>
    </el-table>
    <el-pagination
      v-if="showPagination"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageNo"
      :page-sizes="[5, 10, 50, 100]"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
      </div>
      <div v-else class="jp-common-el-tree-scrollbar el-scrollbar">
          <div class="el-scrollbar__wrap" :style="{height: 500 +'px',marginTop: '20px'}">
            <div class="el-scrollbar__view" style="">     
        <vxe-table
          show-overflow
          :loading="loading"
          ref="xTree"
          :tree-config="{transform: true, rowField: 'id', parentField: 'parentId',expandAll: true,reserve:false}"
          :radio-config="{labelField: 'nameCn'}"
          :row-config="{keyField:'id',isCurrent: true, isHover: true}"
          :checkbox-config="{labelField: 'id', highlight: true,checkRowKeys:checkRowKeys, reserve: true}"
          @checkbox-change="selectChangeEvent"
          @checkbox-all="changeAll"
          :data="dataList">
          <vxe-column type="checkbox" title="全选" width="120" tree-node>
            <template slot-scope="scope"></template>
          </vxe-column>
          <vxe-column field="nameCn" title="名称">
            <template slot-scope="scope">
              <div style="width: 100%;" >{{ scope.row.nameCn }}（{{scope.row.count }}）</div>
            </template>
          </vxe-column>
          <!-- <vxe-column field="nameCn" tree-node>
            <template slot-scope="scope">
              <div style="width: 100%;" @click="handRow(scope.row, 'row')">{{ scope.row.nameCn }}</div>
            </template>
          </vxe-column> -->
        </vxe-table>
      </div>
    </div>
  </div>
    </el-col>
    <el-col :span="10">
      <div class="rightTagbox">
        <el-tag
          :key="tag.id"
          v-for="tag in dataListAllSelections"
          closable
          style="margin-left: 7px;margin-bottom: 7px;"
          :disable-transitions="false"
          @close="del(tag)">
          {{tag[labelName]}}
        </el-tag>
      </div>
      
    </el-col>
    </el-row>
     <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false" icon="el-icon-circle-close">关闭</el-button>
      <el-button size="small" type="primary" icon="el-icon-circle-check" @click="doSubmit()">确定</el-button>
    </span>
    </el-dialog>
  
  </div>
</template>

<script>
  import PopoverTipList from '@/components/popoverTip/indexList.vue'
  import Sortable from 'sortablejs'
  export default {
    data () {
      return {
        searchForms: [],
        filterText: '',
        dataListAllSelections: [],   // 所有选中的数据包含跨页数据
        dataListSelections: [],
        idKey: 'id', // 标识列表数据中每一行的唯一键的名称(需要按自己的数据改一下)
        dataList: [],
        dynamicTags: [],
        selectData: [],
        pageNo: 1,
        pageSize: 10,
        total: 0,
        orders: [],
        loading: false,
        visible: false,
        name: '',
        withoutList: [],
        sortTableRef: null,
        checkRowKeys: [],
        urlHearder: ''
      }
    },
    props: {
      limit: {
        type: Number,
        default: 999999
      },
      columns: {
        type: Array,
        default: () => { return [] }
      },
      params: {
        type: Object,
        default: () => { return {} }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      searchs: {
        type: Array,
        default: () => { return [] }
      },
      dataListUrl: {
        type: String,
        default: () => { return null }
      },
      queryEntityUrl: {
        type: String,
        default: () => { return null }
      },
      value: {
        type: String,
        default: () => { return null }
      },
      title: {
        type: String,
        default: () => { return '' }
      },
      placeholder: {
        type: String,
        default: () => { return '请选择' }
      },
      labelName: {
        type: String,
        default: () => { return '' }
      },
      labelValue: {
        type: String,
        default: () => { return '' }
      },
      size: {
        type: String,
        default: () => { return 'small' }
      },
      showType: {
        type: String,
        default: () => { return 'tag' }
      },
      showPagination: {
        type: Boolean,
        default: true
      }
    },
    components: {
      PopoverTipList
    },
    watch: {
      value: {
        handler (newVal) {
          this.selectData = []
          if (newVal) {
            this.rowDrop()
            newVal.split(',').forEach((value) => {
              if (value) {
                this.$http.get(`${this.queryEntityUrl}?${this.labelValue}=${value}`).then(({data}) => {
                  if (data[this.labelValue] !== '') {
                    this.selectData.push(data)
                  }
                })
              }
            })
          }
        },
        immediate: true,
        deep: false
      },
      selectData: {
        handler (newVal) {
          this.$nextTick(() => {
            this.dataListAllSelections = JSON.parse(JSON.stringify(this.selectData))
            let newList = JSON.parse(JSON.stringify(this.selectData))
            this.withoutList = newList.map(item => {
              // item.fileUrl = item.pic ? process.env.VUE_APP_SERVER_URL + item.pic : ''
              if (item.contentLis && item.contentLis.length > 0) {
                item.contentLis = item.contentLis.map(citem => {
                  citem.fileUrl = citem.coverImage ? process.env.VUE_APP_SERVER_URL + citem.coverImage.filePath : ''
                  return citem
                })
              }
              return item
            })
            this.name = this.dataListAllSelections.map(item => { return item[this.labelName] }).join(',')
          })
        },
        immediate: false,
        deep: true
      }
    },
    methods: {
      async rowDrop () {
        const _this = this
        if (!this.$refs.xTree) return
        const itemBox = this.$refs.xTree.$el.querySelectorAll(
          '.vxe-table--body-wrapper > table > tbody'
        )[0]
        this.sortTableRef = await Sortable.create(itemBox, {
          // handle: '.vxe-body--row',
          animation: 200,
          ghostClass: 'ghost',
          onEnd ({ newIndex, oldIndex }) {
            _this.$nextTick(() => {
              const tableData = _this.withoutList
              const currRow = tableData.splice(oldIndex, 1)[0]
              tableData.splice(newIndex, 0, currRow)
            })
          }
        })
      },
      handTagClose (tag) {
        this.withoutList.splice(this.withoutList.indexOf(tag), 1)
        this.name = this.withoutList.map((item) => {
          return item[this.labelName]
        }).join(',')
        // let value = this.withoutList.map((item) => {
        //   return item[this.labelValue]
        // }).join(',')
        let selectionsIds = this.dataListAllSelections.map((item) => {
          return item[this.labelValue]
        }).join(',')
        this.$emit('getValue', selectionsIds)
      },
      init () {
        this.visible = true
        this.$nextTick(() => {
          this.resetSearch()
        })
      },
      getTemplateRow (index, row) {                                 // 获取选中数据
        this.dataListSelections = [row]
        this.$nextTick(() => {
          this.changePageCoreRecordData()
        })
      },
           // 设置选中的方法
      setSelectRow () {
        if (!this.dataListAllSelections || this.dataListAllSelections.length <= 0) {
          if (this.showType === 'tree') {
            this.$refs.xTree.clearCheckboxReserve()
            this.checkRowKeys = []
          } else {
            this.$refs.gridTable.clearSelection()
          }
          return
        }
                // 标识当前行的唯一键的名称
        let idKey = this.idKey
        let selectAllIds = []
        this.dataListAllSelections.forEach(row => {
          selectAllIds.push(row[idKey])
        })
        if (this.showType !== 'tree') {
          this.$refs.gridTable.clearSelection()
        } else {
          this.checkRowKeys = selectAllIds
        }
        for (var i = 0; i < this.dataList.length; i++) {
          if (selectAllIds.indexOf(this.dataList[i][idKey]) >= 0) {
                        // 设置选中，记住table组件需要使用ref="table"
            if (this.showType === 'tree') {
              // this.$refs.xTree.toggleCheckboxRow(this.dataList[i])
              this.$refs.xTree.setCheckboxRow(this.dataList[i], true)
            } else {
              this.$refs.gridTable.toggleRowSelection(this.dataList[i], true)
            }
          }
        }
      },
      // 记忆选择核心方法
      changePageCoreRecordData () {
                // 标识当前行的唯一键的名称
        let idKey = this.idKey
        let that = this
              // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
        if (this.dataListAllSelections.length <= 0) {
          this.dataListSelections.forEach(row => {
            that.dataListAllSelections.push(row)
          })
          return
        }
                // 总选择里面的key集合
        let selectAllIds = []
        this.dataListAllSelections.forEach(row => {
          selectAllIds.push(row[idKey])
        })
        let selectIds = []
                // 获取当前页选中的id
        this.dataListSelections.forEach(row => {
          selectIds.push(row[idKey])
                  // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
          if (selectAllIds.indexOf(row[idKey]) < 0) {
            that.dataListAllSelections.push(row)
          }
        })
        let noSelectIds = []
              // 得到当前页没有选中的id
        this.dataList.forEach(row => {
          if (selectIds.indexOf(row[idKey]) < 0) {
            noSelectIds.push(row[idKey])
          }
        })
        noSelectIds.forEach(id => {
          if (selectAllIds.indexOf(id) >= 0) {
            for (let i = 0; i < that.dataListAllSelections.length; i++) {
              if (that.dataListAllSelections[i][idKey] === id) {
                                // 如果总选择中有未被选中的，那么就删除这条
                that.dataListAllSelections.splice(i, 1)
                break
              }
            }
          }
        })
      },
     // 得到选中的所有数据
      getAllSelectionData () {
         // 再执行一次记忆勾选数据匹配，目的是为了在当前页操作勾选后直接获取选中数据
        this.changePageCoreRecordData()
      },
      filterNode (value, data) {
        if (!value) return true
        return data.name.indexOf(value) !== -1
      },
      del (tag) {
        this.dataListAllSelections.splice(this.dataListAllSelections.indexOf(tag), 1)
        this.$nextTick(() => {
          if (this.showType === 'tree') {
            this.$refs.xTree.toggleCheckboxRow(tag)
            this.dataListSelections = this.dataListAllSelections
          } else {
            this.setSelectRow()
          }
        })
      },

      // 树形设置
      selectChangeEvent ({ $table }) {
        const records = $table.getCheckboxRecords()
        // console.info(`勾选${records.length}个树形节点`, records)
        this.dataListSelections = records
        this.$nextTick(() => {
          this.changePageCoreRecordData()
        })
      },
      // 树形勾选全部事件
      changeAll ({ checked, $event }) {
        if (checked) {
          this.dataListSelections = this.dataList
        } else {
          this.dataListSelections = []
        }
        this.$nextTick(() => {
          this.changePageCoreRecordData()
        })
      },
      // 获取数据列表
      refreshList () {
        this.loading = true
        let searchForm = {}
        this.searchs.forEach((search, index) => {
          searchForm[search.prop] = this.searchForms[index]
        })
        this.$http({
          url: this.dataListUrl,
          method: 'get',
          params: {
            'current': this.pageNo,
            'size': this.pageSize,
            'orders': this.orders,
            ...searchForm,
            ...this.params
          }
        }).then(({data}) => {
          this.dataList = data.records ? data.records : data
          this.dataList = this.dataList.map(item => {
            item.picJsonList = []
            if (item.picJson) {
              item.picJsonList = JSON.parse(item.picJson).map(citem => {
                citem.fileUrl = this.urlHearder + citem.fileStorePath + citem.filesIn
                return citem
              })
            }
            return item
          })
          this.total = data.total
          this.pageNo = data.current
          this.loading = false
          this.$nextTick(() => {
            this.setSelectRow()
            if (this.showType === 'tree') {
              this.$refs.xTree.setAllTreeExpand(true)
            }
          })
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageNo = 1
        this.refreshList()
        this.$nextTick(() => {
          this.changePageCoreRecordData()
        })
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageNo = val
        this.refreshList()
        this.$nextTick(() => {
          this.changePageCoreRecordData()
        })
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
        this.$nextTick(() => {
          this.changePageCoreRecordData()
        })
      },
      // 排序
      sortChangeHandle (column) {
        this.orders = []
        if (column.order != null) {
          this.orders.push({column: this.$utils.toLine(column.prop), asc: column.order === 'ascending'})
        }
        this.refreshList()
      },
      resetSearch () {
        this.urlHearder = localStorage.getItem('imageDomainName')
        this.$refs.searchForm.resetFields()
        this.searchForms = []
        this.refreshList()
      },
      doSubmit () {
        if (this.limit < this.dataListAllSelections.length) {
          this.$message.error(`你最多只能选择${this.limit}条数据`)
          return
        }
        this.visible = false
        this.name = this.dataListSelections.map((item) => {
          return item[this.labelName]
        }).join(',')
        // let value = this.dataListSelections.map((item) => {
        //   return item[this.labelValue]
        // }).join(',')
        let selectionsIds = this.dataListAllSelections.map((item) => {
          return item[this.labelValue]
        }).join(',')
        this.$emit('getValue', selectionsIds)
      },
      showSelectDialog () {
        this.visible = true
        this.$emit('clearParame')
        this.init()
      }
    }
  }
</script>
<style lang="scss" scoped>
.gridDialog{
  .el-dialog__body {
    padding: 10px 0px 0px 10px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
  .el-pagination{
    margin-top: 5px;
    margin-bottom: 4px;
  }
}
.rightTagbox {
  min-height: 200px;
  max-height: 450px;
  overflow-y: auto;
}
</style>